import { NavLink } from 'react-router-dom'
import { HugeiconsIcon } from '@hugeicons/react'
import { cn } from '@/lib/utils'
import { prefetchInternalRoute } from '@/routes/lazyPages'
import { getNavigationIconMotionHandlers } from './navigationIconMotion'
import { getToolCategoryStyle } from './toolCategoryStyles'

export function ToolTile({ item, compact = false, onSelect }) {
  const motionHandlers = getNavigationIconMotionHandlers(item.motion)
  const categoryStyle = getToolCategoryStyle(item.category)

  const handlePrefetch = () => {
    void prefetchInternalRoute(item.href)
  }

  return (
    <NavLink
      to={item.href}
      onClick={onSelect}
      onMouseEnter={(event) => {
        motionHandlers.onMouseEnter(event)
        handlePrefetch()
      }}
      onFocus={(event) => {
        motionHandlers.onFocus(event)
        handlePrefetch()
      }}
      className={cn(
        'group flex min-w-0 flex-col items-center rounded-lg text-center outline-none transition-colors duration-200 hover:bg-muted/50 focus-visible:bg-muted/50 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        compact ? 'gap-2 p-3' : 'gap-2 p-1',
      )}
      data-cy={`tool-tile-${item.key}`}
    >
      <span
        className={cn(
          'flex shrink-0 items-center justify-center border ring-1 ring-inset ring-foreground/5',
          'shadow-[0_1px_2px_hsl(var(--foreground)/0.08),0_10px_24px_-18px_hsl(var(--foreground)/0.55)]',
          'transition-[transform,box-shadow,border-color,background-color,filter] duration-200',
          'group-hover:-translate-y-0.5 group-hover:shadow-[0_2px_3px_hsl(var(--foreground)/0.08),0_14px_28px_-18px_hsl(var(--foreground)/0.55)]',
          'group-focus-visible:-translate-y-0.5 group-focus-visible:shadow-[0_2px_3px_hsl(var(--foreground)/0.08),0_14px_28px_-18px_hsl(var(--foreground)/0.55)]',
          'group-active:translate-y-0 group-active:scale-[0.96] motion-reduce:transform-none motion-reduce:transition-none',
          compact
            ? 'border-border/80 bg-card text-primary group-hover:border-primary/30 group-hover:bg-accent/20 group-focus-visible:border-primary/30 group-focus-visible:bg-accent/20'
            : `${categoryStyle.icon} group-hover:brightness-95 group-focus-visible:brightness-95 dark:group-hover:brightness-110 dark:group-focus-visible:brightness-110`,
          compact
            ? 'h-14 w-14 rounded-2xl'
            : 'h-[60px] w-[60px] rounded-lg',
        )}
      >
        <HugeiconsIcon
          icon={item.icon}
          size={compact ? 27 : 29}
          strokeWidth={1.65}
          aria-hidden="true"
        />
      </span>
      <span className="w-full min-w-0">
        <span
          className={cn(
            'block text-balance font-medium leading-snug text-foreground',
            compact ? 'text-xs' : 'text-sm',
          )}
        >
          {item.title}
        </span>
      </span>
    </NavLink>
  )
}
